<template>
  <div v-loading="loading"
       class="componentsBody"
       element-loading-text="截图中请稍后..."
       style="position: absolute;
              height: 100%;
              width: 100%;
              top:0;
              z-index: 9999;
              left: 0;">
    <div style="position:fixed;
                float:inherit;
                top: 0px;
                z-index: 999;
                width: 100%;">
      <el-tabs v-model="activeName"
               @tab-click="handleClick"
               style="padding-left: 5%;"
      >
        <el-tab-pane name="first">
          <div slot="label" style="font-size: 18px;">车信报告</div>
        </el-tab-pane>
        <el-tab-pane label="维保报告" name="second"></el-tab-pane>
      </el-tabs>

    </div>

    <div v-show="isTool" style="z-index: 9999;">
      <div style="right: 8%; bottom: 11%; position: fixed; border-radius: 50%; box-shadow: 0 0 3px #d2d6d7;">
        <el-button icon="el-icon-camera" circle @click="doScreenshot()"></el-button>
      </div>
    </div>

    <div style="right: 8%; bottom: 5%; position: fixed;
      box-shadow: 0 0 10px #15b1ec;
      border-radius: 50%">
      <el-button icon="el-icon-menu" type="primary" circle @click="isTool=!isTool"></el-button>
    </div>

    <div>
      <div style="margin-top: 10%;" v-show="activeName == 'second'">
        <iframe :src="wbUrl"  style="width: 100%;height: 1500px;"/>
      </div>
      <div style="margin-top: 10%;" v-show="activeName == 'first'">
        <iframe :src="cxUrl"  style="width: 100%;height: 1500px;"/>
      </div>
    </div>



    <el-dialog
        title="提示"
        :visible.sync="visible"
        width="90%">
      <span style="color: black">
        <b>您还未查询过该车辆的维保报告，确定查询吗？</b>
      </span>
      <span slot="footer" class="dialog-footer">
          <el-button @click="no" type="warning">取消</el-button>
          <el-button @click="yesSearch()" type="primary">确定查询</el-button>
      </span>
    </el-dialog>

    <el-dialog title="请输入密码" :visible.sync="searchPass" width="90%" :before-close="handleClose">
      <el-input placeholder="请输入六位数字密码" type="tel" style="-webkit-text-security: square" maxlength="6" minlength="6" v-model="password"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="no" type="warning" style="color: #000000;">取 消</el-button>
        <el-button type="primary" @click="doMaintenanceOrder()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        :visible.sync="screenshotShow"
        title="长按图片保存到手机"
        style="margin-top: -20%"
        width="95%">
      <div @click="copy()" style="text-align: center">
        <i class="el-icon-link"></i>点击此处复制图片链接
        <span v-if="isCopy" style="color: red">(已复制)</span>
        <i class="el-icon-link"></i>
      </div>
      <div style="height: 500px; overflow-y: auto;">
        <img :src="screenshotUrl" style="width: 100%; height: auto">
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      activeName: 'first',
      wbUrl:'',
      maintenanceUrl: '',
      visible: false,
      orderno: '',
      searchCheck: false,
      cxUrl: '',
      vin:'',
      searchPass: false,
      password: '',
      openId: '',

      screenshotShow: false,
      screenshotUrl: '',
      loading: false,
      isCopy: false,
      isTool: false,
      scrollToTop: '',
    };
  },
  methods: {
    handleClose(done) {
      this.searchPass = false
    },
    yesSearch(){
      this.visible = false
      this.btnShow = true
      this.searchCheck = true
      if(this.searchCheck){
        this.searchPass = true
      }
      //this.doMaintenanceOrder()
    },
    doQuery(){
      this.$api({
        method: 'post',
        url: '/mobileLogin/doQuery',
        params: {
          orderno: this.orderno
        }
      }).then(res => {
        this.cxUrl = res.data
      })
    },
    doMaintenanceOrder(){
      this.visible = false
      this.searchPass = false
      this.$api({
        method: 'post',
        url: '/mobileLogin/doMaintenanceOrder',
        params: {
          orderNumber: this.orderno,
          searchCheck: this.searchCheck,
          password: this.password,
          openId: this.openId
        }
      }).then(res => {
        if(res.data == "未查到该车辆的维保报告"){
          alert(res.data)
          this.no()
        }
        if(res.data == "密码错误..."){
          alert(res.data)
          this.no()
        }
        if(res.data == "车牌号为空,无法查询报告"){
          alert(res.data)
          this.no()
        }
        if(res.data == 401){
          if(this.activeName == "second"){
            this.visible = true
          }
        }
        let str = JSON.stringify(res.data.slice(0,6))
        if(str.includes("账户余额不足")){
          this.no()
          alert(res.data)
        }
        if (res.data.substring(0,4) == 'http') {
          this.visible = false
          this.wbUrl = res.data
        }
      })
    },
    no(){
      this.activeName = "first"
      this.searchPass = false
      this.visible = false
    },
    handleClick(tab, event) {
      if(this.activeName == "second"){
        if(this.wbUrl==''){
          //this.visible = true
          this.doMaintenanceOrder()
        }
      }else if(this.activeName == "first"){
        if(this.cxUrl==''){
          this.doQuery()
        }
      }
    },
    copy(){
      let input = document.createElement("input"); // 创建input对象
      input.value = this.screenshotUrl; // 设置复制内容
      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      this.isCopy = true
    },
    backTop() {
      this.isTool = false
      document.getElementsByClassName('componentsBody')[0].scrollTop = 0
    },
    doScreenshot(){
      this.isCopy = false
      let type = 1
      if(this.activeName == 'first'){
        type = 1
      }else if(this.activeName == 'second'){
        if(this.wbUrl == ''){
          alert("您还未查过维保报告")
          return
        }
        type = 2
      }
      this.loading = true
      this.$api({
        method: 'post',
        url: '/mobileLogin/doScreenshot',
        params: {
          orderno: this.orderno,
          type: type
        }
      }).then(res => {
        this.loading = false
        this.screenshotUrl = res.data
        this.isTool = false
        this.screenshotShow = true
      })
    },
  },
  created() {
    if(localStorage.getItem('openId',this.$route.query.openid) !=undefined && localStorage.getItem('openId',this.$route.query.openid)!=null && localStorage.getItem('openId',this.$route.query.openid)!=''){
      this.openId = localStorage.getItem('openId',this.$route.query.openid)
    }
    if(this.$route.query.openid !=undefined && this.$route.query.openid!=null && this.$route.query.openid!=''){
      this.openId = this.$route.query.openid
    }
    //alert(JSON.stringify(this.$route))
    this.orderno = this.$route.query.orderno
    if(this.$route.query.ordertype == 2){
      this.activeName = "second"
      this.doMaintenanceOrder()
    }else{
      this.doQuery()
    }

  }
};
</script>

<style scoped="scoped">

</style>
